import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FilterModel } from 'src/Models/filterModel';
import { RMDModel } from 'src/Models/TrfaAlertsModel';
import { TrfaAlertService } from 'src/Services/alert.service';
import { CheckAuth } from 'src/Services/utility.service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-user-rmd-alerts',
  templateUrl: './user-rmd-alerts.component.html',
  styleUrls: ['./user-rmd-alerts.component.css']
})
export class UserRmdAlertsComponent implements OnInit {

  tokenKey: string = '';
  isloading: boolean = false;
  filterModel = new FilterModel();
  RMDModel: RMDModel[] = [];
  RMDExportModel: RMDModel[] = [];
  totalRecordCount1: number = -1;
  updateId: number;
  userId: number = 0;
  keywordFilter: string = " ";
  pageNumber: number;
  pageSize: number;
  providerName: string = '';
  orderBy: string;
  upDownEmailCSS: string = '';
  upDownNameCSS: string = '';
  isAscending: boolean;
  openMenuIndex: number = -1;

  constructor(private readonly activedRoute: ActivatedRoute,
    private readonly toastr: ToastrService,
    private readonly router: Router,
    private readonly checkAuth: CheckAuth,
    private readonly trfaAlertServices: TrfaAlertService,
    private readonly titleService: Title,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.titleService.setTitle('RMD Alert Users');
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.RMDModel = [];
    this.keywordFilter = "";
    this.pageNumber = 1;
    this.pageSize = 10;
    this.orderBy = 'updateId ASC';
    this.activedRoute.params.subscribe((params: Params) => {

      if (params['id']) {
        if (params['id'] != null) {
          this.updateId = params['id'];
          this.getUserList();
        }
      }
      else {
        this.updateId = 0;
      }
    });
  }

  keywordFilters($event) {
    this.keywordFilter = $event.target.value;
    //this.filteModel.pageNumber = '1';
    if ($event.target.value != "" && $event.target.value != null) {
      this.keywordFilter = $event.target.value;
    }
    else { this.keywordFilter = ""; }

    this.pageNumber = 1;
    this.getUserList();
  }

  getUserList() {
    this.isloading = true;
    this.RMDModel = [];
    if (this.keywordFilter == "null" || this.keywordFilter == "") { this.keywordFilter = "null"; }
    this.trfaAlertServices.GetRMDAlertsByIds(this.tokenKey, this.updateId, this.pageNumber, this.pageSize, this.keywordFilter, this.userId, this.orderBy, false).subscribe(data => {
      if (data['status'] == 'Success') {
        this.isloading = false;
        this.RMDModel = data['rmdUserList'];
        if (this.RMDModel != null) {
          if (this.RMDModel.length > 0) {
            this.totalRecordCount1 = +this.RMDModel[0].totalRowCount;
          }
          else {
            this.totalRecordCount1 = 0;
          }
        }
        this.providerName = this.RMDModel[0].providerName;
      }
      else {
        this.showMessage(data['status'], 'Error', 'error');
      }

    },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  redirectToEditView(updateId: any, userId: any) {
    this.router.navigate(['/admin/rmd/rmd-Alerts/manage/' + updateId + '/' + userId]);
  }

  pageChanged($event: any) {
    this.pageNumber = parseInt($event.page);
    this.getUserList();
  }

  sort(sortBy: any) {
    this.upDownEmailCSS = '';
    this.upDownNameCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.filterModel.orderBy = sortBy + ' DESC';

      if (sortBy === "email") {
        this.upDownEmailCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "name") {
        this.upDownNameCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.filterModel.orderBy = sortBy;

      if (sortBy === "email") {
        this.upDownEmailCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "name") {
        this.upDownNameCSS = 'fa fa-arrow-up';
      }
    }
    this.pageNumber = 1;
    this.getUserList();
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportRMDAlertuser() {

    this.isloading = true;
    this.RMDExportModel = [];
    if (this.keywordFilter == "null" || this.keywordFilter == "") { this.keywordFilter = "null"; }
    this.trfaAlertServices.GetRMDAlertsByIds(this.tokenKey, this.updateId, this.pageNumber, this.pageSize, this.keywordFilter, this.userId, this.orderBy, true).subscribe(data => {
      if (data['status'] == 'Success') {
        this.RMDExportModel = data['rmdUserList'];
        if (this.RMDExportModel != null) {
          if (this.RMDExportModel.length > 0) {
            setTimeout(() => {
              this.DownloadRMDAlertuser();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
        else {
          this.isloading = false;
          this.toastr.error("No record found", "Error");
        }
      }
      else {
        this.isloading = false;
        this.showMessage(data['status'], 'Error', 'error');
      }

    },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  DownloadRMDAlertuser() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportRMDAlertUsers';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportRMDAlertUsers.xls");
  }
}
